import 'air-datepicker/dist/js/datepicker.min.js';
//import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.ru.js';
import 'air-datepicker/dist/css/datepicker.min.css';

export default (function () {
    var option = {
        dateFormat: 'dd.mm.yyyy',
    };
    $('[data-provide=datepicker]').datepicker(option);
    $('.start__date').datepicker(option);
    $('.end__date').datepicker(option);

    $('.timepicker').datepicker({
        dateFormat: 'dd.mm.yyyy',
        timepicker: true
    })
    

    // function initDatapickerRange() {
    //     $('.start__date').datepicker(option).on('changeDate', function (e) {
    //         var $this = $(this);
    //         $this.parents('.datapicker__range').find('.end__date').datepicker('setStartDate', $this.val());
    //     });

    //     $('.end__date').datepicker(option).on('changeDate', function (e) {
    //         var $this = $(this);
    //         $this.parents('.datapicker__range').find('.start__date').datepicker('setEndDate', $this.val());
    //     });
    // }
    // initDatapickerRange();

    // $('.datetime').datepicker(option).on('changeDate', function (e) {
    //     var $this = $(this);
    //     $this.parents('.datapicker__range').find('.end__date').datepicker('setStartDate', $this.val());
    // });

}())
